import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import DataReportsPage from "@/data/Reports/DataReportsPage";
import PageHeader from "@/components/UI/PageHeader.vue";
import { EReport } from "@/struct/reports/EReport";
import ApiReports from "@/api/ApiReports";
import ApiEnter from "@/api/ApiEnter";
import dayjs from "dayjs";
import ApiAdmin from "@/api/ApiAdmin";
import { EOrderEnum } from "@/struct/order/EOrderEnum";
import ApiShopDiscountCodes from "@/api/ApiShopDiscountCodes";
let ReportsPage = class ReportsPage extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = DataReportsPage.Breadcrumbs;
        this.selectReportType = null;
        this.selectReportTypeItems = [
            {
                text: "Report for logistic department",
                value: EReport.ReportForLogicDepartment
            },
            {
                text: "Report for APN settings",
                value: EReport.ReportForAPNSettings
            },
            {
                text: "Report for order data",
                value: EReport.ReportForOrderData
            },
            {
                text: "Report for discount codes",
                value: EReport.ReportForDiscountCodes
            },
            {
                text: "Report for BSS subscription id",
                value: EReport.ReportForBssSubsId
            }
        ];
        this.selectDiscountCode = null;
        this.selectDiscountCodeItems = [];
        this.settingsPanelState = true;
        this.menuDateFrom = false;
        this.dateFrom = "";
        this.menuDateTo = false;
        this.dateTo = "";
        this.tableHeaders = [];
        this.hasRequest = false;
        this.xlsLink = "";
        this.csvLink = "";
        this.logicDepartamentHeaders = [
            {
                text: "Date",
                value: "create_at"
            },
            {
                text: "Order number",
                value: "id"
            },
            {
                text: "First name",
                value: "first_name"
            },
            {
                text: "Last name",
                value: "last_name"
            },
            {
                text: "Email",
                value: "email"
            },
            {
                text: "Phone number",
                value: "phone"
            },
            {
                text: "Delivery address - Street name",
                value: "delivery_street_name"
            },
            {
                text: "Delivery address - Street number",
                value: "delivery_street_number"
            },
            {
                text: "Delivery address - City",
                value: "delivery_city"
            },
            {
                text: "Delivery address - Province",
                value: "delivery_province"
            },
            {
                text: "Delivery address - ZIP code",
                value: "delivery_zip_code"
            },
            {
                text: "Residential address - Street name",
                value: "residential_street_name"
            },
            {
                text: "Residential address - Street number",
                value: "residential_street_number"
            },
            {
                text: "Residential address - City",
                value: "residential_city"
            },
            {
                text: "Residential address - Province",
                value: "residential_province"
            },
            {
                text: "Residential address - Province",
                value: "residential_zip_code"
            },
            {
                text: "SIM count",
                value: "sim_count"
            },
            {
                text: "Note",
                value: "note"
            }
        ];
        this.apnSettingsHeaders = [
            {
                text: "Date",
                value: "create_at"
            },
            {
                text: "Phone number",
                value: "msisdn"
            },
            {
                text: "O.S.",
                value: "platform"
            },
            {
                text: "Result",
                value: "result"
            }
        ];
        this.orderDataHeaders = [
            {
                text: "Date",
                value: "create_at"
            },
            {
                text: "Order",
                value: "id"
            },
            {
                text: "Customer",
                value: "first_name"
            },
            {
                text: "E-mail",
                value: "email"
            },
            {
                text: "Fiscal Code",
                value: "fiscal_code"
            },
            {
                text: "Phone Number",
                value: "phone"
            },
            {
                text: "Total",
                value: "amount"
            },
            {
                text: "Order Status",
                value: "status"
            },
            {
                text: "Payment status",
                value: "payment_status"
            },
            {
                text: "eSIM",
                value: "esim_count"
            },
            {
                text: "pSIM",
                value: "psim_count"
            },
            {
                text: "Discount Code",
                value: "discount_code"
            }
        ];
        this.discountCodesHeaders = [
            {
                text: "Date",
                value: "create_at"
            },
            {
                text: "Order",
                value: "id"
            },
            {
                text: "Fiscal Code",
                value: "fiscal_code"
            },
            {
                text: "Order Status",
                value: "status"
            },
            {
                text: "Payment status",
                value: "payment_status"
            },
            {
                text: "Total",
                value: "amount"
            },
            {
                text: "Discount amount",
                value: "discount_amount"
            }
        ];
        this.bssSubsIdHeaders = [
            {
                text: "BSS Subscription Id",
                value: "bss_subs_id"
            },
            {
                text: "Date",
                value: "create_at"
            },
            {
                text: "SIM number",
                value: "id"
            },
            {
                text: "Order",
                value: "order_id"
            },
            {
                text: "Fiscal Code",
                value: "fiscal_code"
            },
            {
                text: "SIM Status",
                value: "sim_status"
            },
            {
                text: "Payment status",
                value: "payment_status"
            },
            {
                text: "SIM Type",
                value: "sim_type"
            },
            {
                text: "Discount code",
                value: "discount_code"
            },
            {
                text: "Token Nexi",
                value: "nexi_token"
            },
        ];
        this.tableItems = [];
    }
    get canGenerateReport() {
        if (this.selectReportType === null) {
            // No report type specified
            return false;
        }
        if (!this.dateFrom || !this.dateTo) {
            // No date range specified
            return false;
        }
        if (this.selectReportType === EReport.ReportForDiscountCodes) {
            // Check that discount code is specified
            return !!this.selectDiscountCode;
        }
        return true;
    }
    formatDate(item) {
        const convertDate = dayjs(item).format();
        return dayjs.tz(convertDate, "Europe/Rome").format("DD-MM-YYYY (HH:mm:s)");
    }
    openLink(path) {
        ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, path).then(response => {
            let a = document.createElement("a");
            let file = new Blob([response]);
            a.href = URL.createObjectURL(file);
            a.target = "_blank";
            a.download = path;
            a.click();
        });
    }
    async getReports() {
        this.tableItems = [];
        this.xlsLink = "";
        this.csvLink = "";
        this.hasRequest = true;
        const date_from = this.dateFrom + " 00:00:01";
        const date_to = this.dateTo + " 23:59:59";
        switch (this.selectReportType) {
            case EReport.ReportForLogicDepartment:
                this.tableHeaders = this.logicDepartamentHeaders;
                break;
            case EReport.ReportForAPNSettings:
                this.tableHeaders = this.apnSettingsHeaders;
                break;
            case EReport.ReportForOrderData:
                this.tableHeaders = this.orderDataHeaders;
                break;
            case EReport.ReportForDiscountCodes:
                this.tableHeaders = this.discountCodesHeaders;
                break;
            case EReport.ReportForBssSubsId:
                this.tableHeaders = this.bssSubsIdHeaders;
                break;
            default:
                throw new Error("Unknown selectReportType");
        }
        const response = await ApiReports.getReportsList(ApiEnter.CurrentSessionUUID, date_from, date_to, this.selectReportType, this.selectDiscountCode);
        if (typeof response != "boolean") {
            this.tableItems = response.reports;
            this.xlsLink = response.xlsLink;
            this.csvLink = response.csvLink;
        }
        this.hasRequest = false;
    }
    ValidateAmount(amount) {
        return amount.toFixed(2).replace(".", ",") + "€";
    }
    ValidatePaymentStatus(value, type) {
        const Enums = EOrderEnum.OrderPaymentStatus;
        if (type == "color") {
            if (value === Enums.NotPaid)
                return "grey darken-1 text-white";
            if (value === Enums.Refunded)
                return "red";
            if (value === Enums.PartiallyRefunded)
                return "pink";
            if (value === Enums.Paid)
                return "green";
        }
        if (type == "text") {
            if (value === Enums.NotPaid)
                return this.$t("orders.not_paid");
            if (value === Enums.Refunded)
                return this.$t("orders.refunded");
            if (value === Enums.PartiallyRefunded)
                return this.$t("orders.partially_refunded");
            if (value === Enums.Paid)
                return this.$t("orders.paid");
        }
    }
    ValidateSIMStatus(value, type) {
        const Enums = EOrderEnum.OrderProductSimStatus;
        if (type == "text") {
            if (value === Enums.PendingStartActivation)
                return this.$t("orders.pending");
            if (value === Enums.PendingWaitingKYC)
                return this.$t("orders.pending");
            if (value === Enums.PendingPaymentForNumber)
                return this.$t("orders.pending");
            if (value === Enums.PendingRepeatKYC)
                return this.$t("orders.pending");
            if (value === Enums.PendingFromStartedKYC)
                return this.$t("orders.pending");
            if (value === Enums.PendingFromCompletedKYC)
                return this.$t("orders.pending");
            if (value === Enums.MSISDNReserved)
                return this.$t("orders.pending");
            if (value === Enums.AcceptedFromCompletedKYC)
                return this.$t("orders.activated");
            if (value === Enums.CancelledFailedKYC)
                return this.$t("orders.cancelled");
            if (value === Enums.CancelledByCustomer)
                return this.$t("orders.cancelled");
            if (value === Enums.New)
                return this.$t("orders.new");
            if (value === Enums.InProcess)
                return this.$t("orders.in_process");
            if (value === Enums.InDelivery)
                return "In Delivery";
        }
        if (type == "color") {
            if (value === Enums.PendingStartActivation)
                return "orange";
            if (value === Enums.New)
                return "orange";
            if (value === Enums.InProcess)
                return "orange";
            if (value === Enums.InDelivery)
                return "orange";
            if (value === Enums.PendingWaitingKYC)
                return "orange";
            if (value === Enums.PendingPaymentForNumber)
                return "orange";
            if (value === Enums.PendingRepeatKYC)
                return "orange";
            if (value === Enums.PendingFromStartedKYC)
                return "orange";
            if (value === Enums.PendingFromCompletedKYC)
                return "orange";
            if (value === Enums.MSISDNReserved)
                return "orange";
            if (value === Enums.AcceptedFromCompletedKYC)
                return "green";
            if (value === Enums.CancelledFailedKYC)
                return "red";
            if (value === Enums.CancelledByCustomer)
                return "red";
        }
    }
    ValidateOrderStatus(value, type) {
        const Enums = EOrderEnum.OrderStatus;
        if (type == "color") {
            if (value === Enums.NotFinished)
                return "grey darken-1 text-white";
            if (value === Enums.New)
                return "yellow darken-2 text-black";
            if (value === Enums.InProcess)
                return "orange";
            if (value === Enums.InDelivery)
                return "light-blue";
            if (value === Enums.Delivered)
                return "blue";
            if (value === Enums.Cancelled)
                return "red";
            if (value === Enums.Finished)
                return "green";
            if (value === Enums.PartiallyFinished)
                return "teal darken-2 text-black";
        }
        if (type == "text") {
            if (value === Enums.NotFinished)
                return this.$t("orders.not_finished");
            if (value === Enums.New)
                return this.$t("orders.new");
            if (value === Enums.InProcess)
                return this.$t("orders.in_process");
            if (value === Enums.InDelivery)
                return this.$t("orders.in_delivery");
            if (value === Enums.Delivered)
                return this.$t("orders.delivered");
            if (value === Enums.Cancelled)
                return this.$t("orders.cancelled");
            if (value === Enums.Finished)
                return this.$t("orders.finished");
            if (value === Enums.PartiallyFinished)
                return this.$t("orders.partially_finished");
        }
    }
    allowedDates(value) {
        const yesterday = new Date();
        const selected = new Date(value);
        return yesterday > selected;
    }
    async GetDiscountCodes() {
        try {
            const codes = await ApiShopDiscountCodes.GetDiscountCodes(ApiEnter.CurrentSessionUUID);
            if (!codes) {
                return;
            }
            this.selectDiscountCodeItems = codes;
        }
        catch (e) {
            console.error(e);
        }
    }
    mounted() {
        this.GetDiscountCodes();
    }
};
ReportsPage = __decorate([
    Component({
        components: { StandartTemplate, PageHeader }
    })
], ReportsPage);
export default ReportsPage;
